// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"118":"5fef794e","536":"91477b1c","550":"f39af9b8","867":"759f30cd"}[chunkId] + ".css";
};